<div class="drawer-content-screen">
  <div class="drawer-content-screen__title">
    {{ editingTag ? ('editTag' | translate) : ('createTag' | translate) }}
  </div>

  <div class="drawer-content-screen__body">
    <form class="gap-4" [formGroup]="form" autocomplete="off" novalidate>
      <mat-form-field>
        <mat-label>{{ 'tagLabel' | translate }}</mat-label>
        <input
          matInput
          id="tag"
          formControlName="tag"
          required
          [readonly]="!!editingTag" />
        @if (form.get('tag')?.errors) {
          <mat-error>{{ getErrorMessage() | translate }}</mat-error>
        }
      </mat-form-field>
      <app-tag-color-select class="w-full" formControlName="color" />
    </form>
  </div>
  <div class="flex w-full justify-end">
    <button
      mat-flat-button
      color="primary"
      [disabled]="isLoading || !form.valid"
      (click)="onSubmit()">
      <app-loading-button
        text="{{ 'save' | translate }}"
        [loading]="isLoading"></app-loading-button>
    </button>
  </div>
</div>
